import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useNotifications } from 'src/utils/hooks';

const MEMBER_SERVICES_FOLLOWUP_MUTATION = gql`
  mutation PostMemberServicesFollowUp(
    $addressId: String!
    $conversationId: String
    $reason: String!
    $additionalNotes: String
  ) {
    postMemberServicesFollowUp(
      params: {
        addressId: $addressId
        conversationId: $conversationId
        additionalNotes: $additionalNotes
        reason: $reason
      }
    ) {
      success
    }
  }
`;
export interface MemberServicesFollowUpInput {
  addressId: string;
  conversationId?: string;
  reason: typeof FollowUpReasons;
  additionalNotes?: string;
}

interface MemberServicesFollowUpMutation {
  postMemberServicesFollowUp: { success: boolean };
}

export const FollowUpReasons = {
  'Basic - Non Member - Membership Opportunity': 'Needs Support - Non-Member',
  'Basic - Member - Upgrade Opportunity': 'Needs Support - Member',
  'Basic - Miscellaneous Task': 'Misc - Task',
  'Advanced - Non Member - Membership Opportunity': 'Partner Request - General',
  'Advanced - Member - Upgrade Opportunity': 'Partner Request - General',
  'Advanced - VIP Client': 'Target - FF/VIP Clients',
  'Advanced - Miscellaneous Task': 'Partner Request - General',
  'Client Request - General': 'Client Request - General',
  'Past Due Membership': 'Extended Dunning',
  'Membership Downgrade': 'Client Request - Downgrade',
  'Membership Cancellation': 'Client Request - Cancellation',
};

export const useMemberServicesFollowUp = (
  options?: MutationHookOptions<MemberServicesFollowUpMutation>,
) => {
  const { showSuccessAlert } = useNotifications();

  const [memberServicesFollowUpMutation] = useMutation<MemberServicesFollowUpMutation>(
    MEMBER_SERVICES_FOLLOWUP_MUTATION,
    {
      ...options,
      onCompleted: () => {
        showSuccessAlert('Follow-up submitted');
      },
    },
  );

  const postMemberServicesFollowUp = useCallback(
    async (input: MemberServicesFollowUpInput) => {
      if (!input.addressId || !input.reason) return;

      const { data } = await memberServicesFollowUpMutation({
        variables: {
          ...input,
        },
      });

      return data?.postMemberServicesFollowUp?.success || false;
    },
    [memberServicesFollowUpMutation],
  );

  return {
    postMemberServicesFollowUp,
  };
};
